import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { JobCard } from './JobCard';
import { useRelatedJobs } from '../hooks/useRelatedJobs';
import { useT } from '../i18n/useT';
// "Kapcsolódó állások" blokk a JobDetailView alján.
// A komponens silent skip-pel rendelkezik: ha az admin toggle OFF, vagy üres az eredmény,
// vagy még loading állapotban van, semmit nem renderel (nincs üres heading).
export function RelatedJobs({ currentJobSlug, config }) {
    const enabled = !!config.ui_config?.is_related_jobs_visible;
    const { jobs, loading } = useRelatedJobs(currentJobSlug, enabled);
    const { t } = useT();
    if (!enabled)
        return null;
    if (loading)
        return null;
    if (!jobs || jobs.length === 0)
        return null;
    return (_jsxs("section", { className: "career-related-jobs", children: [_jsx("h2", { className: "career-related-jobs-heading", children: t('related_jobs', 'Kapcsolódó állások') }), _jsx("div", { className: "career-related-jobs-grid", children: jobs.map(job => (_jsx(JobCard, { job: job, config: config }, job.id))) })] }));
}
